import axios from 'axios';
import Component from './Component';
import Pagination from './Pagination';
import Tabs from './Tabs';

import { createElement } from '../support/dom';
import { addClass, hasClass, removeClass } from '../support/classes';

class Posts extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.query = {
            per_page: this.props.perPage || 10,
            page: this.props.page || 1,
            post_type: this.props.postType || 'post',
            tags: this.props.tags || [],
            orderby: this.props.orderby || 'date',
            order: this.props.order || 'desc',
            categories: this.props.categories || [],
            include: this.props.include || [],
            exclude: this.props.exclude || [],
            format: this.props.format || '',
        };

        if (typeof this.query.categories === 'string')
        {
            this.query.categories = this.query.categories.split(',');
        }

        if (typeof this.query.tags === 'string')
        {
            this.query.tags = this.query.tags.split(',');
        }

        if (typeof this.query.include === 'string')
        {
            this.query.include = this.query.include.split(',');
        }

        if (typeof this.query.exclude === 'string')
        {
            this.query.exclude = this.query.exclude.split(',');
        }

        this.totalPages = this.props.totalPages;

        this.initialize();
    }

    initialize()
    {
        this.endpoint = `/${i18n_posts.lang}/wp-json/wp/v2/${this.props.endpoint}`;

        this.element ? this.decorate() : this.render();

        this.initComponents();

        this.bindEvents();

        if (hasClass(this.element, 'loading'))
        {
            this.fetchPosts();
        }
    }

    initComponents()
    {
        this.tabs = M.Tabs.init(this.categories, {});
    }

    decorate()
    {
        if (this.props.showFilters)
        {
            this.decorateFilters();
        }

        if (this.props.showTitle)
        {
            this.decorateTitle();
        }

        this.decorateMessage();
        this.decorateList();

        if (this.props.showPagination)
        {
            this.decoratePagination();
        }
    }

    decorateFilters()
    {
        this.filters = this.element.querySelector('.filters');

        if (this.filters)
        {
            this.decorateCategories();
        }
    }

    decorateCategories()
    {
        const element = this.filters.querySelector('.categories');

        if (!element)
        {
            this.element.appendChild(this.renderFilters());
        }
        else
        {
            this.categories = new Tabs(element, {
                onChange: this._handleCategoryChange,
            });
        }
    }

    decorateTitle()
    {
        this.titleContainer = this.element.querySelector('.block-title');

        if (!this.titleContainer)
        {
            this.element.appendChild(this.renderTitle());
        }
    }

    decorateMessage()
    {
        this.message = this.element.querySelector('.message');

        if (!this.message)
        {
            this.element.appendChild(this.renderMessage());
        }
    }

    decorateList()
    {
        this.list = this.element.querySelector('.posts');

        if (!this.list)
        {
            this.element.appendChild(this.renderList());
        }
    }

    decoratePagination()
    {
        const pagination = this.element.querySelector('.pagination');

        if (pagination)
        {
            this.pagination = new Pagination(pagination, {
                type: this.props.paginationType,
                page: 1,
                total: this.props.totalPages,
                onChange: this._handlePaginationChange,
            });
        }
    }

    render()
    {
        const { element } = this;

        if (this.props.showTitle)
        {
            element.appendChild(this.renderTitle());
        }

        if (this.props.showFilters)
        {
            element.appendChild(this.renderFilters());
        }

        element.appendChild(this.renderMessage());

        element.appendChild(this.renderList());

        if (this.props.showPagination)
        {
            this.pagination = new Pagination(null, {
                type: this.props.paginationType,
                onChange: this._handlePaginationChange,
            });

            element.appendChild(this.pagination.render());
        }
    }

    renderFilters()
    {
        this.filters = this.element.querySelector('.filters');

        if (!this.filters)
        {
            this.filters = createElement('div', null, {
                class: 'filters',
            });
        }

        this.renderCategories();

        this.filters.appendChild(this.categories);

        return this.filters;
    }

    renderCategories()
    {
        const element = this.filters.querySelector('.categories');

        if (element)
        {
            const tabs = [];

            for (let i = 0; i < element.children.length; i++)
            {
                let child = element.children[i];

                tabs.push([child.getAttribute('data-value'), child.textContent]);
            }
        }

        this.categories = new Tabs(element, {
            tabs,
            onChange: this._handleCategoryChange,
        });
    }

    renderTitle()
    {
        const { title, title_link } = this.options;

        this.titleContainer = createElement('div', null, {
            class: 'block-title',
        });

        this.title = createElement('h2', title, {});
        this.titleContainer.appendChild(this.title);

        if (title_link.link)
        {
            this.titleMore = createElement('a', i18n_posts.strings.more, {
                href: title_link.link,
            });
            this.titleContainer.appendChild(this.titleMore);
        }

        return this.titleContainer;
    }

    renderMessage()
    {
        return this.message = createElement('div', null, {
            class: 'message',
        });
    }

    renderList()
    {
        return this.list = createElement('ul', null, {
            class: [
                'posts',
                'blocks',
            ],
        });
    }

    addPosts(posts)
    {
        for (let i = 0; i < posts.length; i++)
        {
            this.addPost(posts[i]);
        }
    }

    addPost(post)
    {
        const element = createElement('li', null, {
            class: [
                'block',
                `block-md-${this.props.postsColumnsMd}`,
                `block-sm-${this.props.postsColumnsSm}`,
                `block-xs-${this.props.postsColumnsXs}`,
            ],
        });

        const link = createElement('a', null, {
            class: 'post',
            href: post.link,
        });

        const title = createElement('h3', post.title.raw || post.title.rendered, {
            class: 'post-title',
        });

        const meta = createElement('ul', null, {
            class: 'post-meta',
        });

        const dateEl = createElement('li', this.formatDate(post.date_gmt + 'Z'), {
            //
        });

        element.appendChild(link);
        link.appendChild(title);
        link.appendChild(meta);
        meta.appendChild(dateEl);

        this.list.appendChild(element);
    }

    formatDate(date)
    {
        return new Date(date).toLocaleDateString();
    }

    clear()
    {
        this.clearList();
        this.clearMessage();
    }

    clearList()
    {
        while (this.list.firstChild)
        {
            this.list.removeChild(this.list.lastChild);
        }
    }

    clearMessage()
    {
        while (this.message.firstChild)
        {
            this.message.removeChild(this.message.lastChild);
        }
    }

    setError(e)
    {
        this.setMessage(e.message);
    }

    setMessage(message)
    {
        this.clearMessage();

        this.message.appendChild(document.createTextNode(message));
    }

    setCategories(categories)
    {
        // Reset the page.
        this.pagination && this.pagination.clear();

        if (typeof categories === 'string')
        {
            categories = categories.split(',');
        }

        this.query.categories = categories;

        this.fetchPosts();
    }

    getCategories()
    {
        return this.query.categories;
    }

    getEndpoint()
    {
        return this.endpoint;
    }

    getAxiosOptions()
    {
        return {
            cancelToken: this.getCancelToken(),
            method: 'get',
            url: this.getEndpoint(),
            responseType: 'json',
            params: Object.assign(
                {
                    lang: i18n_posts.lang,
                },
                this.query,
                {
                    categories: this.getCategories(),
                    page: this.pagination && this.pagination.getPage(),
                }
            ),
        };
    }

    async fetchPosts()
    {
        this.setLoading(true);

        try {
            const { data, status, headers } = await axios(this.getAxiosOptions());

            this.totalPages = headers['x-wp-totalpages'];
            this.total = headers['x-wp-total'];

            this.setData(data);
        }
        catch (e)
        {
            throw e;
            if (axios.isCancel(e))
            {
                return;
            }

            this.setError(e);
        }

        this.setLoading(false);
    }

    setData(data)
    {
        this.clear();

        if (!data.length)
        {
            this.setMessage(i18n_posts.strings.none);
        }
        else
        {
            this.addPosts(data);
        }

        this.pagination && this.pagination.update(this.totalPages);
    }

    getCancelToken()
    {
        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel('Operation canceled due to new request.');
        }

        this.cancelToken = axios.CancelToken.source();

        return this.cancelToken.token;
    }

    setLoading(loading)
    {
        if (loading)
        {
            addClass(this.list, 'loading');
        }
        else
        {
            removeClass(this.list, 'loading');
        }
    }

    _handlePaginationChange = (page) =>
    {
        this.fetchPosts();
    }

    _handleCategoryChange = (tab, value) =>
    {
        if (!value)
        {
            return;
        }

        const categories = value.split(',');

        this.setCategories(categories);
    }

    bindEvents()
    {
        //
    }
}

export default Posts;